<div
  class="sort-header-container"
  [class.mat-sort-header-position-before]="arrowPosition == 'before'"
>
  <div class="content">
    <ng-content></ng-content>
  </div>

  <div class="sort">
    <span
      inlineSVG="/assets/svg/sort-asc.svg"
      class="asc"
      [class.active]="_sort.active === id"
      alt="asc"
      *ngIf="!(_sort.active === id && _sort.direction === 'desc')"
    >
    </span>
    <span
      inlineSVG="/assets/svg/sort-desc.svg"
      class="desc"
      [class.active]="_sort.active === id"
      alt="desc"
      *ngIf="_sort.active === id && _sort.direction === 'desc'"
    ></span>
  </div>
</div>
